import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'

@Component({
  selector: 'lin-input-message-dialog',
  templateUrl: './input-message-dialog.component.html',
  styleUrls: ['./input-message-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InputMessageDialogComponent implements OnInit {
  chatTitle = new FormControl('')

  constructor(@Inject(MAT_DIALOG_DATA) @Optional() private readonly title: string) {}

  ngOnInit(): void {
    this.chatTitle.setValue(this.title)
  }
}
